import api from './api';
import {
  Topic,
  QueryTopicsParams,
  TopicsResponse,
} from '../types/topic';

export const topicService = {
  /**
   * Get all topics with filters and pagination
   */
  async getAll(params: QueryTopicsParams = {}): Promise<TopicsResponse> {
    const queryParams = new URLSearchParams();

    // Page context (maps to categories on backend)
    if (params.page) queryParams.append('page', params.page);

    // Category filter (comma-separated or single, overrides page context)
    if (params.category) queryParams.append('category', params.category);

    if (params.search) queryParams.append('search', params.search);
    if (params.isPopular !== undefined) queryParams.append('isPopular', params.isPopular.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.pageNumber) queryParams.append('pageNumber', params.pageNumber.toString());
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive.toString());
    if (params.section) queryParams.append('section', params.section);

    const queryString = queryParams.toString();
    return api.get(`/topics${queryString ? `?${queryString}` : ''}`);
  },

  /**
   * Get topic by slug
   */
  async getBySlug(slug: string): Promise<Topic> {
    return api.get(`/topics/${slug}`);
  },

  /**
   * Get topics by category
   */
  async getByCategory(category: string): Promise<Topic[]> {
    return api.get(`/topics/category/${category}`);
  },

  /**
   * Get popular topics
   */
  async getPopular(limit = 3): Promise<Topic[]> {
    return api.get(`/topics/popular?limit=${limit}`);
  },

  /**
   * Enroll in a topic
   */
  async enroll(id: string): Promise<void> {
    return api.post(`/topics/${id}/enroll`);
  },
};

